document.addEventListener("DOMContentLoaded", () => {
  const grid = document.getElementById("Huratips-Loop");
  if (!grid) return;

  const getCols = () => {
    // Your grid already has inline: style="--wg-cols: 5;"
    const v = parseInt(getComputedStyle(grid).getPropertyValue("--wg-cols"), 10);
    if (Number.isFinite(v) && v > 0) return v;

    // fallback: count actual CSS grid columns
    const cols = getComputedStyle(grid).gridTemplateColumns.split(" ").length;
    return cols || 1;
  };

  const applyFillers = () => {
    // remove old fillers first
    grid.querySelectorAll(".grid-filler").forEach(el => el.remove());

    const cols = getCols();

    // count only real product items (ignore fillers)
    const items = grid.querySelectorAll(":scope > .grid-item, :scope > .col").length;

    const remainder = items % cols;
    if (remainder === 0) return;

    const needed = cols - remainder;

    for (let i = 0; i < needed; i++) {
      const filler = document.createElement("div");
      filler.className = "grid-filler col"; // keep same class family so it grids
      filler.setAttribute("aria-hidden", "true");
      grid.appendChild(filler);
    }
  };

  applyFillers();

  // Re-run when columns change / viewport changes
  window.addEventListener("resize", applyFillers);

  // Re-run if grid class changes (your 3/4/5-col toggles do this)
  const obs = new MutationObserver(applyFillers);
  obs.observe(grid, { attributes: true, attributeFilter: ["class", "style"], childList: true });
});
